<div class="new-pop">
  <h1>{{language.ENTER_OTP}}</h1>
  <div class="form-group">
    <input autocomplete="off" [(ngModel)]="otpnumer" placeholder="{{language.ENTER_OTP}}" #otpno>
  </div>
  <div class="flx-btn">
    <button (click)="submitOtp()" class="sbm-btn cmn-button" cdkFocusInitial>{{language.SUBMIT}}</button>
  </div>
</div>
